export default __webpack_public_path__ + "static/media/u6-ubahn-neubauprojekte-wien.54cc8526.svg";